import { Component, OnInit } from '@angular/core';
import { FunctionsService } from '../../services/functions.service';
import { UsersService } from '../../services/users.service';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { Companies } from '../../models/companies.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-company-list',
  templateUrl: './admin-company-list.component.html',
  styleUrls: ['./admin-company-list.component.scss']
})
export class AdminCompanyListComponent implements OnInit {

  userType: any;
  companiesList: any;


  baseURL = environment.apiUrl;
  constructor(public functionsService: FunctionsService, private usersService: UsersService, private router: Router, private httpService: HttpService) {

    this.userType = this.usersService.getUserType();
    if (!this.usersService.isAuth() || this.userType != 'admin') {
      this.router.navigate(['/admin']);
    }
  }

  ngOnInit(): void {
    this.loadCompanies();
    this.baseURL;
  }

  loadCompanies() {
    this.companiesList = [];
    if (localStorage.getItem('companies') != undefined) {
      const dataString: any = localStorage.getItem('companies');
      const list: [] = JSON.parse(dataString);
      list.forEach(element => {
        const companies = new Companies(element);
        this.companiesList.push(companies);
      });
    }
  }

}
